import React from "react";
import { Images } from "../../assets";
import { Button } from "../../components";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  const startJourney = () => {
    navigate("calculateCarbonFootprint");
  };
  return (
    <div className="flex justify-center place-items-center ">
      <div className="flex justify-center place-items-center">
        <div className="flex flex-col gap-8 max-w-[80%]">
          <p className="font-bold text-6xl">Calculate your carbon footprint</p>
          <p>
            Discover your personal impact on the environment and take actionable
            steps to lower your carbon emissions today!
          </p>
          <Button onClick={startJourney} title="Start Your Journey" />
        </div>
      </div>
      <img
        className="hidden md:flex"
        src={Images.placeholder_Image}
        alt="placeholder image"
      />
    </div>
  );
}
